import React, { useState, useMemo, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner
} from 'reactstrap'
// core components
import styled from 'styled-components'
import SimpleHeader from 'components/Headers/SimpleHeader.js'
import { useDashboardContext } from '../../contexts/DashboardContext'
import { useAccessControlContext } from '../../contexts/AccessControlContext'

const SimDetailsRow = styled(Row)`
  margin-left: 0px;
  margin-top: 10px;
  max-width: 100%;
`;

function SimLookup() {
  const { getDealerSimDetails, getProductList, updateDealerSimDetails } =
    useDashboardContext()
  const { getSimDetailsFeatures } = useAccessControlContext()
  const [simDetailsFeatures, setSimDetailsFeatures] = useState(
    getSimDetailsFeatures()
  )
  const history = useHistory()
  const [iccid, setIccid] = useState('')
  const [msisdn, setMsisdn] = useState(null)
  const [getSimError, setGetSimError] = useState('')
  const [isValid, setIsValid] = useState(false)
  const [simStatus, setSimStatus] = useState(null)
  const [simPlan, setSimPlan] = useState(null)
  const [simStatusId, setSimStatusId] = useState(null)
  const [orderId, setOrderId] = useState(null)
  const [showDetails, setShowDetails] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (iccid?.length !== 10) {
      setIsValid(false)
    } else {
      setIsValid(true)
    }
  }, [iccid])
  
  useEffect(() => {
    setShowDetails(false)
    setGetSimError('')
    if (iccid.length !== 10) {
      return
    }
    setIsLoading(true)
    const getDealerSimStatus = async () => {
      await getDealerSimDetails({
        // iccidFilter is the last 10 digits of the iccid
        iccidFilter: iccid.slice(-10)
      })
        .then((res) => {
          setSimPlan(res.planName)
          setSimStatusId(res.statusId)
          setOrderId(res.orderId)
          setMsisdn(res.msisdn)
          // TODO: replace this with the configured default msisdn
          if (res.msisdn === '0400000000') {
            setMsisdn('')
          }
          if (res.dnaStatus === 'Reserved' || res.orderId !== null) {
            setSimStatus('Reserved')
          } else {
            setSimStatus(res.statusDescr)
          }
          setShowDetails(true)
          setIsLoading(false)
        })
        .catch((err) => {
          setIsLoading(false)
          setShowDetails(false)
          setGetSimError('SIM not found')
          console.log('error happened during getting dealerSimDetails():', err)
        })
      }
    getDealerSimStatus()
  }, [
    getDealerSimDetails,
    iccid,
  ])

  // // The trigger function behind the activate button
  // const handleActivate = () => {
  //   console.log('activate')
  //   // jump to the activation page, auto-fill the msisdn
  //   history.push({
  //     pathname: '/admin/search/activate',
  //     state: {
  //       iccid: iccid.slice(-10)
  //     }
  //   })
  // }


  return (
    <>
      <SimpleHeader name="SIM Lookup" />
      <Container fluid>
        <Card>
          <CardHeader>
            <Row className="align-items-center">
              <Col xs="8">
                <h3 className="mb-0 text-primary neue-bold letter-2">
                  Look up a SIM's details
                </h3>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className="text-primary">
            <Form
              // onSubmit={(e) => {
              //   e.preventDefault()
              //   handleSubmit()
              // }}
            >
              <div className="pl-lg-4">
                <FormGroup row>
                  <Label className="letter-4" htmlFor="input-nickname" md={2}>
                    ICCID last 10 digits
                  </Label>
                  <Col md={6}>
                    <Input
                      id="input-nickname"
                      type="text"
                      value={'X'.repeat(10) + iccid}
                      onChange={(e) => {
                        setGetSimError('')
                        setIccid(e.target.value.replace(/[^0-9]/gi, ''))
                      }}
                      maxLength={20}
                      invalid={!!getSimError}
                    />
                    <div className="invalid-feedback">{getSimError}</div>
                  </Col>
                </FormGroup>
                {isLoading ? (
                  <div className="d-flex justify-content-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <></>
                )}
                {showDetails && (
                  <SimDetailsRow>
                    <FormGroup row style={{width: '100%'}}>
                      <Label className="letter-4" htmlFor="sim-status" md={2}>
                        Status
                      </Label>
                      <Col className="d-flex align-items-center" md={10}>
                        <h>{simStatus}</h>
                      </Col>
                      <Label className="letter-4" htmlFor="sim-msisdn" md={2}>
                        MSISDN
                      </Label>
                      <Col className="d-flex align-items-center" md={10}>
                        <h>{msisdn}</h>
                      </Col>
                      <Label className="letter-4" htmlFor="sim-plan" md={2}>
                        Plan Name
                      </Label>
                      <Col className="d-flex align-items-center" md={10}>
                        <h>{simPlan}</h>
                      </Col>
                    </FormGroup>
                  </SimDetailsRow>
                )}
              </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </>
  )
}

export default SimLookup
